import { render } from "./WhenThingsGoWrong.vue?vue&type=template&id=3822c6b6"
import script from "./WhenThingsGoWrong.vue?vue&type=script&lang=js"
export * from "./WhenThingsGoWrong.vue?vue&type=script&lang=js"

import "./WhenThingsGoWrong.vue?vue&type=style&index=0&id=3822c6b6&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__